var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',_vm._g(_vm._b({staticClass:"base-button-back",attrs:{"text":"","small":""}},'v-btn',_vm.$attrs,false),_vm.$listeners),[_c('img',{attrs:{"src":_vm.svgSource,"alt":"back-button","onload":"SVGInject(this)"}}),_c('span',{staticClass:"ml-2"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }